import { render, staticRenderFns } from "./PartnerSettingAccount.vue?vue&type=template&id=4ff3bca4"
import script from "./PartnerSettingAccount.vue?vue&type=script&lang=js"
export * from "./PartnerSettingAccount.vue?vue&type=script&lang=js"
import style0 from "./PartnerSettingAccount.vue?vue&type=style&index=0&id=4ff3bca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports